import { useAuth, useClerk } from "@clerk/react";
import { UserCheck } from "lucide-react";
import { api } from "@/lib/api";
import { useMe } from "@/context/MeContext";

export function ImpersonationBanner() {
  const { actor } = useAuth();
  const { signOut } = useClerk();
  const { me } = useMe();
  if (!actor) return null;
  const stop = async () => {
    try { await api.post("/impersonation/end"); } catch { /* session already closed */ }
    await signOut({ redirectUrl: "/sign-in" });
  };
  return (
    <div className="bg-amber-100 border-b border-amber-300 text-amber-900 text-sm px-4 py-2 flex flex-wrap items-center gap-3" data-testid="impersonation-banner">
      <UserCheck className="h-4 w-4" />
      <span>Mode remplacement : vous voyez la plateforme comme <b>{me?.name || me?.email}</b>. Toutes vos actions sont tracées.</span>
      <button onClick={stop} className="ml-auto font-semibold underline" data-testid="impersonation-end-btn">Terminer (vous devrez vous reconnecter)</button>
    </div>
  );
}
